import { SelectLanguageOption } from "@features/language/change-language";
import { Link } from "react-router-dom";




export function LogoAndLanguage(){
  
  
  return (
    <div className="flex justify-between items-center mb-10">
      <Link to={"/login"}>
        <img src={"/fixransomware-logo-white.png"} width={200} />
      </Link>
      <SelectLanguageOption />
    </div>
  )
}